// NEW: UI_REVAMP
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
	components: {
		Button: {
			baseStyle: {
				transition: 'none',
				transform: 'none',
				_disabled: {
					opacity: 1,
					cursor: 'not-allowed',
				},
				cursor: 'pointer',
			},
		},
		Input: {
			baseStyle: {
				_disabled: {
					opacity: 1,
					cursor: 'not-allowed',
				},
				cursor: 'default',
			},
		},
	},
	fonts: {
		heading: `'Roboto', sans-serif`,
		body: `'Roboto', sans-serif`,
	},
	config: {
		initialColorMode: 'light',
		useSystemColorMode: false,
	},

	colors: {
		orange: {
			500: '#F47B0B',
		},
		blue: {
			100: '#F9FAFC',
			150: '#ECF3FF',
			200: '#EDF3FF',
			230: '#D3E1FC',
			250: '#2688E1',
			300: '#BDCCF3',
			350: '#200DF8',
			400: '#F9FBFF',
			500: '#0052FF',
			600: '#3AA9DC',
			700: '#003198',
			800: '#1650CD',
		},

		gray: {
			50: '#EDEDED',
			100: '#E0E0E0',
			200: '#D2D8E4',
			300: '#A0A0A0',
			400: '#9D9B9B',
			500: '#696969', //errorMsg in login/register
			600: '#C4C4C4',
			700: '#F0F0F0',
		},

		green: {
			100: '#CFF1D7',
			300: '#07E738',
			400: '#36CC45',
			450: '#29B247',
			500: '#22943B',
			600: '#1A6E2C',
		},

		red: {
			100: '#FED7D7',
			200: '#FCE5E6',
			400: '#E52A2A',
			500: '#DA100B',
			600: '#C53834',
		},
		myColor: {
			500: '#ff0000', // Replace with your desired color
		},
		resultCardBg:
			'radial-gradient(67.44% 67.44% at 3.31% 90%, #FFEB7C 0%, rgba(255, 243, 173, 0.63) 37.18%, rgba(255, 255, 255, 0.00) 100%), radial-gradient(123.33% 11.37% at 80.88% 95.59%, #7DEAFF 0%, rgba(125, 234, 255, 0.00) 100%), radial-gradient(61.7% 38.28% at 86.91% 18.31%, #FFF 0%, rgba(203, 185, 224, 0.00) 100%), radial-gradient(47.22% 47.22% at 66.91% 23.97%, #FFF 0%, rgba(255, 255, 255, 0.00) 100%), radial-gradient(99.15% 30.53% at 78.53% 91.54%, #6ED1FF 0%, rgba(215, 202, 255, 0.00) 100%), radial-gradient(89.81% 28.84% at 2.65% 53.68%, #FFEB7C 0%, rgba(254, 145, 186, 0.00) 100%), radial-gradient(90.75% 67.34% at 17.94% 48.6%, rgba(231, 0, 87, 0.90) 0%, rgba(254, 145, 186, 0.20) 76.38%, rgba(255, 255, 255, 0.00) 100%), radial-gradient(171.95% 75.95% at 71.18% 76.91%, #B39AFF 0%, rgba(255, 255, 255, 0.00) 100%), #FFF',
	},

	breakpoints: {
		sm: '340px',
		sm2: '700px',
		md: '960px',
		lg: '1024px',
		xl: '1440px',
		'2xl': '1920px',
		'3xl': '2560px',
	},
});

export default theme;
